import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { getMissingIbnInstallationsFetchProps } from 'src/Libs/installations/utils'
import { makeStyles } from 'tss-react/mui'
import { ApiView } from '@e3dc-react/shell/Elements/ApiView'
import { TableCellPadding } from '@e3dc-react/shell/Elements/Table/types'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import { Breakpoints } from 'src/Configuration/breakpoints'
import { BlankViewImageVariants, BlankView, BlankViewImageSizes } from 'src/Components/blank-view'
import {
  InstallationMissingIbnTableColumns,
  useInstallationMissingIbnTableColumns,
  useFilteredInstallationsNavigation,
} from 'src/Libs/installations/hooks'
import InstallationSearchField from '../../InstallationSearchField'

const useStyles = makeStyles()(theme => ({
  installationsMissingIbnTable: {
    display: 'flex',
    overflowX: 'hidden',
    [theme.breakpoints.down('sm')]: {
      'table tr th:last-of-type': {
        width: '80px',
      },
    },
    [theme.breakpoints.down('lg')]: {
      overflowX: 'auto',
    },
  },
  tableHeader: {
    whiteSpace: 'pre-line',
  },
  inputFilter: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 0,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper2,
    borderRadius: theme.shape.borderRadius,
  },
}))

/**
 * display installations with missing ibn, in the 'Missing IBN' tab,
 * on the installer dashboard overview.
 */
const MissingIbnInstallations: React.FC = () => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down(Breakpoints.Mobile))

  const { tableColumnsMd, tableColumnsSm } = useInstallationMissingIbnTableColumns()
  const { onChange, filterQuery, filterString } = useFilteredInstallationsNavigation('deviceId')

  const tableColumns = downSm ? tableColumnsSm : tableColumnsMd

  const missingIbnInstallationsFetchProps = getMissingIbnInstallationsFetchProps(filterQuery)

  return (
    <>
      <Box className={classes.inputFilter}>
        <InstallationSearchField label={t('installation-statement.overviewTable.deviceId')} value={filterString} onChange={onChange} />
      </Box>
      <ApiView<InstallationMissingIbnTableColumns>
        key={2}
        containerClassName={classes.installationsMissingIbnTable}
        fetchProps={missingIbnInstallationsFetchProps}
        tableColumns={tableColumns}
        hasColoredTableColumns
        isMobilePaginator={downSm}
        dataQaPrefix={'installations-missing-ibn'}
        collapsibleContentPadding={TableCellPadding.Checkbox}
        headerClassName={classes.tableHeader}
        onSelectOnlyInList
        bodyElevation={0}
        footerElevation={0}
        headerElevation={0}
        listElevation={0}
        scrollMarginTop={135}
        onlyTable
        blankView={
          <BlankView
            imageVariant={BlankViewImageVariants.Happy}
            imageSize={BlankViewImageSizes.Small}
            title={'companyDashboard.blank-view.missing-ibn-installation.title'}
            explanation={'companyDashboard.blank-view.missing-ibn-installation.explanation'}
            fullHeight
          />
        }
      />
    </>
  )
}

export default MissingIbnInstallations
